
import { Component, Vue } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import AppConsts from '@/lib/appConst';
import Util from '@/lib/util';
import Tiptop from '@/components/headers/tiptop.vue';
import HeaderCommon from './header-common.vue';
import BreadcrumbNav from '@/components/breadcrumb-nav.vue';

@Component({
  components:{Tiptop,HeaderCommon,BreadcrumbNav}
})
export default class Header extends AbpBase{
  
  get currentPath () {
    return this.$store.state.app.currentPath;
  }
}
